import http from '@/utils/ajax'
import { UOM_INIT_LOADING, UOM_INIT_SUCCESS, UOM_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [UOM_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [UOM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [UOM_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  }
}

const actions = {
  async uomManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.uomManagement
    commit(UOM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(UOM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(UOM_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
